export default function addIdToDataGridRows(rows) {
    return rows.map((item, index) => {
        return {...item, id: index}
    })
}